// Presentation preview only. Python validates and owns every persistent byte.
export type RegisterDraft = {
  octave: number; semitone: number; fine: number; nphony: number;
  sourceSlots: (number | null)[];
};
export function topologyDraft(instrument: any): RegisterDraft[] {
  return (instrument.topology?.registers ?? []).map((r: any) => ({
    octave: r.octave, semitone: r.semitone, fine: r.fine, nphony: r.nphony,
    sourceSlots: [...r.source_slots],
  }));
}
export function topologyPreview(registers: RegisterDraft[]) {
  const positions = registers.reduce((total, r) => total + r.sourceSlots.length, 0);
  const channels = registers.reduce((total, r) => total + r.sourceSlots.length * r.nphony, 0);
  const errors: string[] = [];
  if (positions > 8) errors.push(`Voice-position capacity exceeded: ${positions} / 8`);
  if (channels > 8) errors.push(`Physical channel capacity exceeded: ${channels} / 8`);
  if (registers.length > 8) errors.push('At most eight registers are supported.');
  for (const [index, r] of registers.entries()) {
    if (!Number.isInteger(r.nphony) || r.nphony < 1 || r.nphony > 8 || r.sourceSlots.length < 1 || r.sourceSlots.length > 8) errors.push(`Register ${String.fromCharCode(65 + index)} requires 1–8 Voice positions and polyphony 1–8.`);
    if (![r.octave, r.semitone, r.fine].every(Number.isInteger) || Math.abs(r.octave) > 6 || Math.abs(r.semitone) > 127 || Math.abs(r.fine) > 99) errors.push(`Register ${String.fromCharCode(65 + index)} has invalid tuning.`);
  }
  let channel = 0;
  const routing = errors.length ? [] : registers.map(r => {
    const masks = r.sourceSlots.map(() => 0);
    for (let round = 0; round < r.nphony; round++) for (let ordinal = 0; ordinal < masks.length; ordinal++) masks[ordinal] |= 1 << channel++;
    return { masks, union: masks.reduce((union, mask) => union | mask, 0) };
  });
  return { positions, channels, errors, routing };
}
